import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transformation-database-settings',
  templateUrl: './transformation-database-settings.component.html',
  styleUrls: ['./transformation-database-settings.component.scss']
})
export class TransformationDatabaseSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
